// src/components/EventProductionBanner.js
import React from 'react';
import './EventProductionBanner.css'; // Reuse the same CSS styles

const EventProductionBanner = () => {
  return (
    <div className="service-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">Event Production</h2>
      </div>
    </div>
  );
};

export default EventProductionBanner;
